'use client';

import type { Menu } from '@eliadmin/core/src/api/general/types/general-layout-types';
import { CategoryMenu, CategoryMenuItem } from './category-menu';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function HeaderMenu({ menu, isHomepage }: { menu: Menu[]; isHomepage?: boolean }) {
  return (
    <div className={cn('flex max-w-full flex-wrap items-center gap-4', 'ea-header-menu')}>
      {menu.map(menuItem => {
        return (
          <CategoryMenu
            key={menuItem.name}
            className={cn('ea-header-menu', 'items-center justify-center gap-4 lg:gap-8')}
          >
            {menuItem.fields?.map(item => {
              return (
                <CategoryMenuItem
                  key={item.path}
                  href={item.path}
                  title={item.name}
                  className={isHomepage ? { link: 'text-white hover:text-white/80' } : undefined}
                />
              );
            })}
          </CategoryMenu>
        );
      })}
    </div>
  );
}
